const formatDateString = (inputDateString) => {
       
    const parsedDate = new Date(inputDateString);

    const formattedDate = `${parsedDate.getDate()}/${parsedDate.getMonth() + 1}/${parsedDate.getFullYear()}`;

    return formattedDate;
  };

  export {formatDateString}

  // 1073,1074
  // const formattedDate = new Date(BookedOn).toISOString();
  // const formattedDate2 = new Date(ExpiryDate).toISOString();